module.exports = __webpack_public_path__ + "static/media/playstore.60908e9a.svg";